/**
 * @generated SignedSource<<97ff028ad1fa56d934b052887de9e586>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$data = {
  readonly text: string | null;
  readonly " $fragmentType": "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader";
};
export type ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$key = {
  readonly " $data"?: ContemporaryLandingTextHeaderModule_contemporaryLandingHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingTextHeaderModule_contemporaryLandingHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingHeader",
  "abstractKey": null
};

(node as any).hash = "8e672d8cb57995f34e322f12cf68ea48";

export default node;
